import type { ReactElement, Ref } from "react";
import styles from "./AvatarButton.module.scss";

interface AvatarButtonProps {
    /** The avatar's name; the button reads "Open {name}". */
    name: string;
    onClick: () => void;
    /** One circle or square avatar; the button takes its shape. */
    children: ReactElement;
    ref?: Ref<HTMLButtonElement>;
}

/**
 * Makes an avatar the whole click target, e.g. an entity that opens its
 * client. Adds a neutral hover and press overlay and the focus ring; the
 * avatar itself has no states.
 */
export const AvatarButton = ({
    name,
    onClick,
    children,
    ref,
}: Readonly<AvatarButtonProps>) => (
    <button
        ref={ref}
        type="button"
        aria-label={`Open ${name}`}
        className={styles.button}
        onClick={onClick}
    >
        {children}
    </button>
);
